import { css } from "@emotion/react";

export const styles = {
  carouselContainer: css`
    padding-bottom: var(--spacing-24);
    p {
      font-size: var(--font-size-12);
      color: var(--color-secondary);
    }
  `,
  pageContainer: css`
    height: 100%;
    overflow-y: auto;
  `,
  pickerWrapper: css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: auto;
    *.bp4-button.icon {
      padding: var(--spacing-8);
    }
  `,
  pickerOrbContainer: css`
    display: flex;
    justify-content: center;

    padding: 0 var(--spacing-32);

    button .kit-Display {
      padding: var(--spacing-4);
      min-width: auto;
      min-height: auto;
      width: auto;
      height: auto;
    }
  `
};
